// extracted by mini-css-extract-plugin
export default {"button":"button_eYOktr9","button_light":"button_light_JYcJdJp","button_dark":"button_dark_QnZarWV","buttonIcon":"buttonIcon_jc9gPpV"};